import { TEventLogo } from "../../../components/EventLogo/EventLogo";

export const showSecondLine = (eventLogo?: TEventLogo | null) => {
    if (!eventLogo) return true;
    if ("additionalText" in eventLogo) {
        return !eventLogo.additionalText;
    }
    return true;
}
